<template>
    <p class="y-alert" :class="`y-alert-${type}`">
        <slot></slot>
    </p>
</template>
<script>
// warning
// warning2
// secondary
// primary
// primary2
// success
// error
export default {
    props: {
        type: {
            default: 'success'
        }
    }
}
</script>